import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

function Footer({ ContactRef, HomeRef }) {
  return (
    <Container>
      <Logo
        onClick={() => {
          HomeRef.current.scrollIntoView({
            behavior: "smooth",
          });
        }}
      >
        <img src="./images/logo1.png" alt="logointhefooter" />
      </Logo>

      <QuickLinks>
        <h4>Quick Links</h4>

        <div className="sc-footer-list">
          <Link
            onClick={() =>
              HomeRef.current.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            Home
          </Link>
          <Link to="/work">Work</Link>
          <Link to="/talent">Talent</Link>
          <Link
            onClick={() =>
              ContactRef.current.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            Contact
          </Link>
        </div>
      </QuickLinks>

      <Connect>
        <h4>Connect</h4>

        <div className="sc-footer-list">
          <a href="https://www.google.com">
            <img src="./images/Facebook.png" alt="facebook" />
          </a>

          <a
            href="https://instagram.com/nutrire_luxury?igshid=MWI4MTIyMDE="
            target={"_blank"}
            rel="noreferrer"
          >
            <img src="./images/Instagram.png" alt="instagram" />
          </a>
        </div>
      </Connect>
      <Contact>
        <h4>Contact</h4>

        <div className="sc-footer-list">
          <a href="mailto:info@nutriremanagement.com">
            <img src="./images/letter.png" alt="email" />
            info@nutriremanagement.com
          </a>
        </div>
      </Contact>
    </Container>
  );
}
const Container = styled.div`
  background-color: #000;
  padding: 60px 10px;

  display: flex;
  flex-direction: row;
  margin: auto;
  justify-content: space-around;

  @media only screen and (max-width: 955px) {
    flex-direction: column;
  }

  .sc-footer-list {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    @media only screen and (max-width: 955px) {
      flex-direction: row;
      width: 250px;
      justify-content: space-around;
    }
  }
`;

const Logo = styled.div`
  width: 200px;
  cursor: pointer;
  img {
    width: 100%;
  }

  @media only screen and (max-width: 955px) {
    margin-left: 20px;
  }
`;

const QuickLinks = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;

  h4 {
    font-size: 18px;
    color: #bababa;
  }

  a {
    margin-top: 10px;
    text-decoration: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    transition: 0.3s all ease-in-out;
    &:hover {
      color: #c9a34e;
      transition: 0.3s all ease-in-out;
    }
  }

  @media only screen and (max-width: 955px) {
    margin-left: 20px;
  }
`;

const Connect = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;

  h4 {
    font-size: 18px;
    color: #bababa;
  }
  a {
    margin-top: 10px;
    text-decoration: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
  }

  @media only screen and (max-width: 955px) {
    margin-left: 20px;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;

  h4 {
    font-size: 18px;
    color: #bababa;
  }

  a {
    margin-top: 10px;
    text-decoration: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;

    display: flex;
    align-items: center;

    img {
      margin-right: 20px;
    }
  }

  @media only screen and (max-width: 955px) {
    margin-left: 20px;
  }

  .sc-footer-list {
    @media only screen and (max-width: 955px) {
      margin-left: 20px;
    }
  }
`;

export default Footer;
